import React from 'react'
import { Menu, Space } from 'antd'
import { NavLink } from 'react-router-dom'
import { routersPath } from '@router/routes-path'
import DropdownUI from '@components/ui/DropDownUI/DropdownUi'
import {
  IconBank,
  IconGlobe,
  IconRocket,
  IconInvoice,
  IconLinkAlt,
  IconChartBar,
  IconSettings,
  IconDatabase,
  IconAngleDown,
  IconBriefcase,
  IconSackDollar,
  IconSearchText,
  IconUsersGroup,
  IconReceiptText,
  IconDollarSendSquare,
  IconDollarReceiveSquare,
} from '@utils/icons'

export interface ITabs {
  title: JSX.Element | Element
  pages: routersPath[]
}

export const adminTabs: ITabs[] = [
  {
    title: (
      <NavLink to={routersPath.MAIN_PAGE} className={({ isActive }) => (isActive ? 'active' : '')}>
        <IconChartBar width='22' height='22' fill='var(--color-main)' />
        Статистика
      </NavLink>
    ),
    pages: [routersPath.MAIN_PAGE],
  },
  {
    title: (
      <NavLink to={routersPath.CRMS} className={({ isActive }) => (isActive ? 'active' : '')}>
        <IconDatabase width='22' height='22' fill='var(--color-main)' />
        {"Управление CRM's"}
      </NavLink>
    ),
    pages: [routersPath.CRMS],
  },
  {
    title: (
      <NavLink to={routersPath.AUTOMATION} className={({ isActive }) => (isActive ? 'active' : '')}>
        <IconRocket width='22' height='22' fill='var(--color-main)' />
        Автоматизация
      </NavLink>
    ),
    pages: [routersPath.AUTOMATION],
  },
  {
    title: (
      <DropdownUI
        menu={
          <Menu
            items={[
              {
                key: routersPath.REPORTS,
                label: (
                  <NavLink to={routersPath.REPORTS}>
                    <span>Отчеты</span>
                  </NavLink>
                ),
                icon: <IconReceiptText width='22' height='22' fill='var(--color-main)' />,
              },
              {
                key: routersPath.INCOMES,
                label: (
                  <NavLink to={routersPath.INCOMES}>
                    <span>Приходы</span>
                  </NavLink>
                ),
                icon: <IconDollarSendSquare width='22' height='22' fill='var(--color-main)' />,
              },
              {
                key: routersPath.EXPENSES,
                label: (
                  <NavLink to={routersPath.EXPENSES}>
                    <span>Расходы</span>
                  </NavLink>
                ),
                icon: <IconDollarReceiveSquare width='22' height='22' fill='var(--color-main)' />,
              },
              {
                key: routersPath.SALARY,
                label: (
                  <NavLink to={routersPath.SALARY}>
                    <span>Зарплаты</span>
                  </NavLink>
                ),
                icon: <IconSackDollar width='22' height='22' fill='var(--color-main)' />,
              },
            ]}
          />
        }
      >
        <Space>
          <span>
            <IconReceiptText width='22' height='22' fill='var(--color-main)' />
            Отчеты
          </span>

          <span className='arrow'>
            <IconAngleDown width='16' height='16' fill='#fff' />
          </span>
        </Space>
      </DropdownUI>
    ),
    pages: [
      routersPath.REPORTS,
      routersPath.REPORT,
      routersPath.INCOMES,
      routersPath.EXPENSES,
      routersPath.SALARY,
    ],
  },
  {
    title: (
      <DropdownUI
        menu={
          <Menu
            items={[
              {
                key: routersPath.USERS,
                label: (
                  <NavLink to={routersPath.USERS}>
                    <span>Пользователи</span>
                  </NavLink>
                ),
                icon: <IconUsersGroup width='22' height='22' fill='var(--color-main)' />,
              },
              {
                key: routersPath.TARIFFS,
                label: (
                  <NavLink to={routersPath.TARIFFS}>
                    <span>Тарифы</span>
                  </NavLink>
                ),
                icon: <IconBriefcase width='22' height='22' fill='var(--color-main)' />,
              },
              {
                key: routersPath.COUNTRIES,
                label: (
                  <NavLink to={routersPath.COUNTRIES}>
                    <span>Страны</span>
                  </NavLink>
                ),
                icon: <IconGlobe width='22' height='22' fill='var(--color-main)' />,
              },
              {
                key: routersPath.BILLING,
                label: (
                  <NavLink to={routersPath.BILLING}>
                    <span>Оплаты</span>
                  </NavLink>
                ),
                icon: <IconInvoice width='22' height='22' fill='var(--color-main)' />,
              },
            ]}
          />
        }
      >
        <Space>
          <span>
            <IconSettings width='22' height='22' fill='var(--color-main)' />
            Настройки
          </span>

          <span className='arrow'>
            <IconAngleDown width='16' height='16' fill='#fff' />
          </span>
        </Space>
      </DropdownUI>
    ),
    pages: [routersPath.USERS, routersPath.BILLING],
  },
  {
    title: (
      <DropdownUI
        menu={
          <Menu
            items={[
              {
                key: routersPath.USER_PERSONAL_ACCOUNTS,
                label: (
                  <NavLink to={routersPath.USER_PERSONAL_ACCOUNTS}>
                    <span>Личные кабинет</span>
                  </NavLink>
                ),
                icon: <IconBank width='22' height='22' fill='var(--color-main)' />,
              },
              {
                key: routersPath.PERSONAS_ACCOUNT_DOMAINS,
                label: (
                  <NavLink to={routersPath.PERSONAS_ACCOUNT_DOMAINS}>
                    <span>Домены кабинетов</span>
                  </NavLink>
                ),
                icon: <IconLinkAlt width='20' height='20' fill='var(--color-main)' />,
              },
            ]}
          />
        }
      >
        <Space>
          <span>
            <IconBank width='22' height='22' fill='var(--color-main)' />
            Личные кабинеты
          </span>

          <span className='arrow'>
            <IconAngleDown width='16' height='16' fill='#fff' />
          </span>
        </Space>
      </DropdownUI>
    ),
    pages: [routersPath.USER_PERSONAL_ACCOUNTS, routersPath.PERSONAS_ACCOUNT_DOMAINS],
  },
  {
    title: (
      <NavLink to={routersPath.SEARCH}>
        <IconSearchText width='22' height='22' fill='var(--color-main)' />
        Поиск
      </NavLink>
    ),
    pages: [routersPath.SEARCH, routersPath.SEARCH_USER],
  },
]
